import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=27bf1d08&scoped=true&"
import script from "./detailsPage.js?vue&type=script&lang=js&"
export * from "./detailsPage.js?vue&type=script&lang=js&"
import style0 from "./detailsPage.vue?vue&type=style&index=0&id=27bf1d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bf1d08",
  null
  
)

export default component.exports